import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { Redirect, Switch } from 'react-router-dom';

import buildsReducer from './reducers';

const importRDCBuilds = () => import(/* webpackChunkName: "builds" */ './containers/RDCBuildContainer');
const importVDCBuilds = () => import(/* webpackChunkName: "builds" */ './containers/VDCBuildWrapper');
const importVDCBuildOpenSourceContainer = () => import(/* webpackChunkName: "builds" */ './containers/VDCBuildOpenSourceWrapper');

const BuildRoutes = ({ match }) => (
  <Switch>
    <BundleRoute
      exact
      load={importRDCBuilds}
      path={`${match.url}/rdc/:buildId/:tabName?`}
    />
    <BundleRoute
      exact
      load={importVDCBuilds}
      path={`${match.url}/vdc/:buildId/:tabName?`}
    />
    <BundleRoute
      exact
      load={importVDCBuildOpenSourceContainer}
      path={`${match.url}/user/:username/vdc/:buildId/:tabName?`}
    />
    <Redirect
      from={`${match.url}/user/:username/vdc-v2/:buildId/:tabName?`}
      to={`${match.url}/user/:username/vdc/:buildId/:tabName?`}
    />
    <Redirect
      from={`${match.url}/vdc-v2/:buildId/:tabName?`}
      to={`${match.url}/vdc/:buildId/:tabName?`}
    />
    <Redirect
      from={`${match.url}/:buildId/:tabName?`}
      to={`${match.url}/vdc/:buildId/:tabName?`}
    />
  </Switch>
);

BuildRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.builds', attachReducer(buildsReducer),
)(BuildRoutes);
